// extracted by mini-css-extract-plugin
export default {"logoContainer":"Logo_logoContainer__N5xXU","logoTitle":"Logo_logoTitle__dhgpD"};